function ValidationMessage({ message }) {
    if (!message) return null;

    return <span className="validation-error">{message}</span>;
}

export default ValidationMessage;
